export const texts = {
  analysis: {
    de: 'Analyse',
    en: 'Analysis'
  }
};
